module.exports = "#auditTrail dd {\n  word-break: break-word;\n  white-space: pre-line;\n}\n"